import { createContext, useContext, useState, useCallback, useEffect } from 'react'

const NotificationsContext = createContext(null)
const STORAGE_KEY = 'clixyads_notifications'

const defaultNotifications = []

function loadFromStorage() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) return JSON.parse(stored)
  } catch { /* ignore */ }
  return defaultNotifications
}

export function NotificationsProvider({ children }) {
  const [notifications, setNotifications] = useState(loadFromStorage)

  // Persistir cambios en localStorage
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(notifications))
    } catch { /* ignore */ }
  }, [notifications])

  const unread = notifications.filter(n => !n.read).length

  const markRead = useCallback((id) => {
    setNotifications(prev => prev.map(n => n.id === id ? { ...n, read: true } : n))
  }, [])

  const markAllRead = useCallback(() => {
    setNotifications(prev => prev.map(n => ({ ...n, read: true })))
  }, [])

  const dismiss = useCallback((id) => {
    setNotifications(prev => prev.filter(n => n.id !== id))
  }, [])

  const add = useCallback((notification) => {
    setNotifications(prev => [{ id: Date.now(), read: false, time: 'Ahora', ...notification }, ...prev])
  }, [])

  const clearAll = useCallback(() => {
    setNotifications([])
  }, [])

  return (
    <NotificationsContext.Provider value={{ notifications, unread, markRead, markAllRead, dismiss, add, clearAll }}>
      {children}
    </NotificationsContext.Provider>
  )
}

export function useNotifications() {
  return useContext(NotificationsContext)
}
